import { AxiosPromise } from 'axios';

import type { JobImprovedDto } from '../models';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';

class JobClient extends BaseClient {
  getJobImproved(jobImprovedId: number): AxiosPromise<JobImprovedDto> {
    return this.request({
      url: `${hosts.reachoutApi}/job-improved/${jobImprovedId}/`,
      method: 'GET',
    });
  }
}

export const jobClient = new JobClient();
